import React, { useContext } from 'react';
//import { Link } from 'react-router-dom';
import { AppSettings } from '../../../config/app-settings.js';
import PrivateImage from '../../auth/private-image.jsx';

function DropdownProfile() {
  const context = useContext(AppSettings);
  const user_data = context.userInfo; // App.jsxでセットした情報を取得
  // 表示名の判定ロジック
  const user = user_data ? user_data.user_info : null;
  const displayName = user ? (
    user.nickname ? user.nickname : `${user.last_name} ${user.first_name}`
  ) : 'ゲスト';

  return (
    <div className="navbar-item navbar-user dropdown">
      <a href="#/" className="navbar-link dropdown-toggle d-flex align-items-center" data-bs-toggle="dropdown">
        <PrivateImage filename={user?.profile} alt="Profile" />
        <span>
          <span className="d-none d-md-inline fw-bold">{displayName}</span>
          <b className="caret"></b>
        </span>
      </a>
      <div className="dropdown-menu dropdown-menu-end me-1">
        <a href="#/" className="dropdown-item">Edit Profile</a>
        <a href="#/" className="dropdown-item d-flex align-items-center">
          Inbox
          <span className="badge bg-danger rounded-pill ms-auto pb-4px">2</span>
        </a>
        <a href="#/" className="dropdown-item">Calendar</a>
        <a href="/settings" className="dropdown-item">Settings</a>
        <div className="dropdown-divider"></div>
        <a href="/logout" className="dropdown-item">Log Out</a>
      </div>
    </div>
  );
};

export default DropdownProfile;
